import { useRecordContext, useListContext } from 'react-admin';
import { Box } from '@mui/material';
import { Growth } from '@/components/analytics/common/Growth';
import { DEFAULT_PERIOD } from '@/components/analytics/PeriodFilters.jsx';

export const MarketShare = () => {
    const { filterValues } = useListContext();
    const currentPeriod = filterValues?.period ?? DEFAULT_PERIOD;
    const record = useRecordContext();
    const analytics = record?.analytics?.[currentPeriod];
    const marketShare = analytics?.marketShare;
    const previousMarketShare = analytics?.previousMarketShare;

    if (marketShare === null || marketShare === undefined) {
        return '-';
    }
    const marketSharePercent = marketShare * 100;

    let marketShareChange = null;
    if (previousMarketShare !== null && previousMarketShare !== undefined && previousMarketShare !== 0) {
        marketShareChange = ((marketShare - previousMarketShare) / previousMarketShare) * 100;
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '37px' }}>
            <Box sx={{ fontSize: '14px', fontWeight: 600, lineHeight: '20px' }}>{marketSharePercent.toFixed(1)}%</Box>
            {marketShareChange !== null && Number.isFinite(marketShareChange) && (
                <Growth value={marketShareChange} className='growth--small' decimalPlaces={1} sx={{ '& .MuiChip-label': { fontWeight: '600 !important' } }} />
            )}
        </Box>
    );
};
